<template>
  <tm-formatted-text-renderer
    :content="content"
    skip-italic
    skip-line-feed
  />
</template>

<script setup lang="ts">
import { computed, unref } from '@/composition/vue/compositionApi'
import { useBreakpoints } from '@/composition/breakpoints'
import TmFormattedTextRenderer from '@/components/shared/TmFormattedTextRenderer.vue'
import { getTranslateService } from '@/core/container/ioc'

const props = defineProps<{
  firstIndex: number
  lastIndex: number
  total?: number
  totalFormatted: string
  entity: string
}>()

const { isMobile } = useBreakpoints()

const translateService = getTranslateService()

const content = computed<string>(() => {
  return translateService.t(
    unref(isMobile) ? 'tmTableFooter.pageNavigationTextShort' : 'tmTableFooter.pageNavigationTextFull',
    {
      itemsRange: `${props.firstIndex}-${props.lastIndex}`,
      itemsTotal: props.totalFormatted,
      entity: translateService.getLowerCaseEntityLabel(props.entity, props.total),
    },
  )
})
</script>
